import { EFieldType, IFormFieldsMeta, IListColumnMeta } from 'shared/types/Page.interface';

/** Поля создания ЗИП из карточки машины: клиент прикладывает файлы. */
export const UNFORMALIZED_ZIP_CREATE_FORM_FIELDS: IFormFieldsMeta = [
  {
    name: 'docUrlUuids',
    label: 'Вложения',
    type: EFieldType.file,
    required: true,
    accept: '.pdf,.doc,.docx,.jpg,.jpeg,.png,.xls,.xlsx',
    maxCount: 5,
    buttonText: 'Загрузить файлы',
    buttonSize: 'small',
    fileType: 'document',
  },
];

export const UNFORMALIZED_ZIP_TABLE_COLUMNS: IListColumnMeta = [
  {
    title: 'Статус',
    type: EFieldType.select,
    dataIndex: 'status',
    options: {
      NEW: 'Новый',
      COMPLETED: 'Завершен',
    },
    sortingPriority: 3,
  },
  {
    title: 'Дата создания',
    type: EFieldType.dateTime,
    dataIndex: 'createdAt',
    sourceFormat: 'YYYY-MM-DDTHH:mm:ss',
    targetFormat: 'DD.MM.YYYY HH:mm',
    sortingPriority: 4,
  },
  {
    title: 'Дата обновления',
    type: EFieldType.dateTime,
    dataIndex: 'updatedAt',
    sourceFormat: 'YYYY-MM-DDTHH:mm:ss',
    targetFormat: 'DD.MM.YYYY HH:mm',
    sortingPriority: 5,
  },
];
